import { apiList, $payedAPI } from '@/api'

export default {
    namespaced: true,
    actions: {
        async analyzeFile(_, { file }) {
            const formData = new FormData()
            formData.append('snils_scan', file)

            try {
                const resp = await $payedAPI({
                    method: apiList.aidocscanner.analyzeImageByFile.method,
                    url: apiList.aidocscanner.analyzeImageByFile.handler,
                    data: formData
                })
                return resp.data
            } catch (error) {
                // Maybe add sentry
                return null
            }
        }
    }
}
